export default "/images/9caf3188785befe1aa5199b94a07c65b.avif";